import http from '../../../../libs/http'
const api = process.env.VUE_APP_MICROSERVICE_API_SHOPS

export default (payload = {
  // date: new Date(),
  articulos: []
}) => http.post(`${api}/inventary-entry`, payload)
